// extracted by mini-css-extract-plugin
module.exports = {"link":"Breadcrumb_link__lGu1Q","disabled":"Breadcrumb_disabled__2XJoa","text":"Breadcrumb_text__2Uel2"};